import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Editor, Toolbar } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { catchError, debounceTime, distinctUntilChanged, Observable, of, OperatorFunction, switchMap, tap } from 'rxjs';
import { CategoryService } from 'src/app/_services/category.service';
import { CompoundService } from 'src/app/_services/compound.service';
import { HammaddeService } from 'src/app/_services/hammadde.service';
import { PropertyService } from 'src/app/_services/property.service';
import { ReportService } from 'src/app/_services/report.service';
import { AddcategoryComponent } from 'src/app/category/addcategory/addcategory.component';
import { NoealComponent } from './noeal/noeal.component';
import { SuitableComponent } from './suitable/suitable.component';
import * as Decimal from 'decimal.js';
@Component({
  selector: 'app-newreport',
  templateUrl: './newreport.component.html',
  styleUrls: ['./newreport.component.css']
})
export class NewreportComponent implements OnInit,OnDestroy {
  submitted=false;
  definitionForm:FormGroup;
  elementType:string='1';

  compounds:any[]=[];
  constructor( 
       private properrtyService:PropertyService,
       private formBuilder:FormBuilder,
       private compoundService :CompoundService,
      private categorySerivice:CategoryService,
      private toastr: ToastrService,
      private productService:ReportService,
      private hammaddeService:HammaddeService,
      private modal:NgbModal,
      ) { }
  editor: Editor;
  editorb: Editor;
  editor3: Editor;
  editor4: Editor;
  editormikro:Editor;
  editorsaf:Editor;
  editorsafdevam:Editor;
  editorusage:Editor;
  editordegerlendirme:Editor;
  editorprofile:Editor;
  editora9:Editor;
  editora10:Editor;

  editorb1:Editor;
  editorb2:Editor;
  editorb3:Editor;
  editorb4:Editor;
  editor2a:Editor;
  parfume='0';
  properties:any[];
  showmikro=false;
  showsaf=false;
  sedData:any[]=[];
  mosData:any[]=[];
  a2=false;

  usage=`<p><strong>5) Normal ve makul olarak öngörülebilir kullanım</strong></p>

<ul>
  <li><strong>Etiket bilgisi:</strong></li>
  <li><strong>Ürün kullanım şekli ve kullanım sıklığı:</strong></li>
  <li><strong>Ürünün Normal ve Makul Olarak Öngörülebilir Kullanım Yeri ve Kullanım Miktarı:</strong></li>
  <li><strong>Etikette yer alan uyarılar:</strong></li>
</ul>
`;
  usageen=`<p><strong>5) Normal and reasonably foreseeable use</strong></p>

<ul>
  <li><strong>Label Information:</strong></li>
  <li><strong>Product usage instructions and frequency of use:</strong></li>
  <li><strong>Normal and reasonably foreseeable location of use and amount of use of the product:</strong></li>
  <li><strong>Warnings on the label:</strong></li>
</ul>
`;


  safdevam=`<p>Üründeki hammaddelerden kaynaklanan safsızlıklar, ürün bilgi dosyasındaki hammadde bilgileri bölümünde bulunmaktadır. Bitmiş üründe risk oluşturacak hiçbir safsızlık bulunmamaktadır.</p>
<p>Üretici tarafından GMP beyanı veya GMP belgesi haricinde üretimden kaynaklanan safsızlıklar ve kalıntılar hakkında herhangi bir bilgi tarafımıza sunulmamıştır.</p>

<p><strong>b) Yasaklı madde kalıntılarının teknik olarak kaçınılmazlığının kanıtı</strong></p>
<p>Bitmiş üründe kalıntı olarak bulunan yasaklı maddeler için herhangi bir bilgi tarafımıza sunulmamıştır.</p>

<p><strong>c) Ambalaj materyalinin ilgili özellikleri</strong></p>
<p>Bitmiş ürün ile doğrudan temas halinde olan ambalaj materyalinin ilgili özellikleri:</p>
<p>Ambalaj materyali olarak cam şişe ve plastik kapak kullanılmıştır. Ürün …. ml/gr olarak satılmaktadır.</p>
`;
  safdevamen=`<p>Impurities arising from the raw materials in the product are provided in the raw material information section of the product information file. No impurities that would pose a risk are present in the finished product.</p>

<p>No information regarding impurities and residues originating from production, other than the GMP declaration or GMP certificate by the manufacturer, has been provided to us.</p>

<p><strong>b) Evidence of the technical unavoidability of traces of prohibited substances</strong></p>
<p>No information has been provided to us regarding prohibited substances found as residues in the finished product.</p>

<p><strong>c) Relevant characteristics of the packaging material</strong></p>
<p>Relevant characteristics of the packaging material in direct contact with the finished product:</p>
<p>The packaging material used is a glass bottle with a plastic cap.</p>
`;


  saf=`<p><strong>4) Safsızlıklar, kalıntılar, ambalaj materyali hakkında bilgi</strong></p>
<p>Bu başlık altında kozmetik ürünlerin formülasyonuna kasten eklenmeyen maddeleri içerip içermediği ve bunların güvenlilik üzerinde etkisinin olup olmadığı incelenecektir.</p>

<p><strong>a) Maddeler ve karışımların saflığı</strong></p>
<p>Safsızlık ve kalıntılar gibi istenmeyen maddelerin varlığı, bitmiş ürünün güvenliliği üzerinde etkili olabilir. İlgili istenmeyen maddeler toksikolojik olarak belirlenmekte, hammaddelerin (maddeler ve karışımlar) saflığı hakkında veriler eklenmektedir.</p>
`;

safen=`<p><strong>3) Information on impurities, traces, and packaging material</strong></p>
<p>It will be examined whether the cosmetic product contains substances that were not intentionally added to its formulation and whether they have any impact on safety.</p>

<p><strong>a) Purity of substances and mixtures</strong></p>
<p>The presence of undesirable substances such as impurities and residues may impact the safety of the finished product. Relevant undesirable substances are identified toxicolgically, and data regarding the purity of raw materials (substances and mixtures) are included.</p>
`;


  mikro=`<p><strong>3) Mikrobiyolojik Kalite</strong></p>

<p><strong>a) Maddeler ve Karışımların Mikrobiyolojik Kalitesi</strong></p>
<p>
  Üretim yeri tarafından sağlanan hammaddelerin mikrobiyolojisine dair deklarasyon ve üründe kullanılan hammaddelerin dokümanları ekte sunulmuştur.
</p>

<p><strong>b) Bitmiş Ürünün Mikrobiyolojik Kalitesi</strong></p>
<p>
  Özel bir popülasyonda ve/veya hassas vücut bölgelerinde kullanılması amaçlanan kozmetik ürünlerin mikrobiyolojik spesifikasyonlarına özellikle dikkat edilmelidir. 
  Göz çevresinde, genel olarak mukoza zarlarında, hassas deride, üç yaş altı çocuklarda, yaşlılarda veya riskli bağışıklık yanıtı gösteren kişilerde kullanılması planlanan 
  kozmetik ürünlerin mikrobiyolojik spesifikasyonları büyük önem arz etmektedir.
</p>

<ul>
  <li>
    Farklı cilt bölgeleri farklı hassasiyete sahip olabileceğinden kozmetik ürünler için iki ayrı kategori tanımlanmıştır:
    <ul>
      <li>3 yaş altı çocuklara yönelik ürünler, göz çevresine uygulanan ürünler, mukoza zarlarına uygulanan ürünler <strong>Kategori 1</strong>’de yer alır.</li>
      <li>Diğer ürünler <strong>Kategori 2</strong> kapsamında değerlendirilir.</li>
    </ul>
  </li>
</ul>

<p>
  <strong>Kategori 1:</strong> Toplam canlı aerobik mezofilik mikroorganizma sayısı (bakteri, maya ve küf) 
  <strong>10² cfu/g</strong> ya da <strong>10² cfu/ml</strong>’den fazla olmamalıdır.<br>
  <strong>Kategori 2:</strong> Toplam canlı aerobik mezofilik mikroorganizma sayısı 
  <strong>10³ cfu/g</strong> ya da <strong>10³ cfu/ml</strong>’den fazla olmamalıdır.
</p>

<p>
  “Türkiye İlaç ve Tıbbi Cihaz Kurumu Kozmetik Ürünlerin Mikrobiyolojik Kontrolüne İlişkin Kılavuz” gereği, kozmetik ürünlerde kesinlikle bulunmaması gereken mikroorganizmalar:
</p>

<ul>
  <li>Staphylococcus aureus</li>
  <li>Pseudomonas aeruginosa</li>
  <li>Candida albicans</li>
  <li>Escherichia coli</li>
</ul>

<p><strong>Mikrobiyolojik test raporu</strong>, raporun sonunda sunulmuştur.</p>

<p><strong>Challenge Test Sonucu ve Değerlendirmesi</strong></p>
<p>
  Koruyucu etkinlik çalışmalarının sonuçları (örneğin: tarama-zorlama testi / challenge test), koruyucunun etkinliğini değerlendirmek amacıyla gerçekleştirilmiştir.
</p>
<p>
  Koruyucu etkinlik test sonucuna göre, üretici bu üründe koruyucunun etkinliğini deneysel olarak garanti etmiştir.
</p>
<p><strong>Challenge test raporu</strong>, raporun sonunda sunulmuştur.</p>
`;
  mikroEng=`
<p><strong>3) Microbiological Quality</strong></p>

<p><strong>a) Microbiological Quality of Substances and Mixtures</strong></p>
<p>
  The declaration regarding the microbiology of the raw materials provided by the place of manufacture and the documents for the raw materials used in the product are attached.
</p>

<p><strong>b) Microbiological Quality of the Finished Product</strong></p>
<p>
  Special attention should be paid to the microbiological specifications of cosmetic products intended for use on special populations and/or sensitive body areas. 
  The microbiological specifications of cosmetic products planned for use around the eyes, generally on mucous membranes, on sensitive skin, in children under three years old, 
  in the elderly, or in individuals with compromised immune responses, are of great importance.
</p>

<ul>
  <li>
    Since different areas of the skin may have varying sensitivities, two separate categories have been defined for cosmetic products:
    <ul>
      <li>Products intended for children under the age of 3, products applied around the eyes, and products applied to mucous membranes are classified under <strong>Category 1</strong>.</li>
      <li>Other products are classified under <strong>Category 2</strong>.</li>
    </ul>
  </li>
</ul>

<p>
  <strong>Category 1:</strong> The total count of viable aerobic mesophilic microorganisms (bacteria, yeast, and mold) must not exceed <strong>10² cfu/g</strong> or <strong>10² cfu/ml</strong>.<br>
  <strong>Category 2:</strong> The total count of viable aerobic mesophilic microorganisms must not exceed <strong>10³ cfu/g</strong> or <strong>10³ cfu/ml</strong>.
</p>

<p>
  According to the "<em>Türkiye İlaç Ve Tıbbi Cihaz Kurumu Kozmetik Ürünlerin Mikrobiyolojik Kontrolüne İlişkin Kılavuz</em>" by the Turkish Medicines and Medical Devices Agency, 
  the microorganisms that must not be present in cosmetic products are:
</p>

<ul>
  <li>Staphylococcus aureus</li>
  <li>Pseudomonas aeruginosa</li>
  <li>Candida albicans</li>
  <li>Escherichia coli</li>
</ul>

<p><strong>The microbiological test report</strong> is provided at the end of the report.</p>

<p><strong>Challenge Test Result and Evaluation</strong></p>
<p>
  Results of preservative efficacy studies, such as the challenge test.
</p>
<p>
  According to the preservative efficacy test result, the manufacturer has experimentally guaranteed the effectiveness of the preservative in this product.
</p>
<p><strong>The challenge test report</strong> is provided at the end of the report.</p>
`;

degerlendirme=`<p><strong>7) Formülde yer alan maddelere maruziyet değerlendirmesi</strong></p>

<p>İnsan maruziyeti, kozmetik ürünün belirtilen fonksiyonlarına ve kozmetik bileşenin kullanımına, ürün içinde bulunan miktarına ve kullanım sıklığına göre uygun verilerle hesaplanır. Maruziyet düzeyinin belirlenmesi sistemik dolaşıma geçen, takiben doku/organlara dağılan miktarın hesaplanması yani kozmetik ürünlerde sistemik maruziyet dozunun (SED) hesaplanması ile yapılır.</p>

<p><strong>SED değerleri hesaplanırken aşağıdaki formül kullanılmaktadır:</strong></p>

<p>• Birim yüzeyindeki dermal absorbsiyon miktarı (µg/cm²) biliniyorsa:</p>
<p><code>SED = [DAa(µg/cm²) × 10⁻³ (mg/µg) × SSA(cm²) × F(gün⁻¹) × R] / 60 (kg)</code></p>

<p>• Uygulanan ürünün % dermal absorpsiyon miktarı biliniyorsa:</p>
<p><code>SED = A(mg/kg vücut ağırlığı/gün) × C(%) / 100 × DAp(%) / 100</code></p>

<p><strong>Tanımlar:</strong></p>
<ul>
  <li><strong>SED (Sistemik Maruziyet Dozu):</strong> Kan dolaşımına geçmesi beklenen kozmetik bileşenin mg/kg vücut ağırlığı/gün cinsinden miktarıdır.</li>
  <li><strong>A:</strong> Vücut ağırlığının kg’ı başına uygulanan ürün miktarı ile uygulama sıklığına bağlı olarak bir kozmetik ürüne günlük maruziyet (mg/kg/gün)</li>
  <li><strong>C:</strong> Maruziyeti hesaplanacak maddenin bitmiş ürün içerisindeki % konsantrasyonu</li>
  <li><strong>DAp:</strong> Gerçek yaşam şartlarında uygulandığı farz edilen test dozunun yüzdesi olarak ifade edilen dermal absorbsiyon oranı (örn. %50 alınabilir)</li>
  <li><strong>Retansiyon Faktörü:</strong> Kozmetik ürünün kullanımından sonra ciltte ne kadarının kaldığını gösteren katsayı</li>
</ul>

<p><strong>Ürün Fonksiyonu:</strong> {{pf}}</p>
<p><strong>A değeri:</strong> {{au}}</p>
<p><strong>Koruyucular için A değeri:</strong> Tüm kozmetik ürünlerdeki günlük toplam maruziyet göz önüne alınarak; 2,79 g/gün veya 269 mg/kg/gün değeri MoS hesaplamasında kullanılmalıdır.</p>
<p><strong>Yüzey Alanı:</strong> {{ya}}</p>
<p><strong>Ortalama Vücut Ağırlığı:</strong> {{we}}</p>
<p><strong>Referans:</strong> {{ref}}</p>
`;
degerlendirmeen=`<p><strong>6) Exposure assessment of the substances in the formulation</strong></p>

<p>Human exposure is calculated using appropriate data based on the specified functions of the cosmetic product, the use of the cosmetic ingredient, its concentration in the product, and the frequency of use. The determination of the exposure level is done by calculating the amount that enters the systemic circulation and subsequently distributes to tissues/organs, i.e., the calculation of the systemic exposure dose (SED) in cosmetic products.</p>

<p><strong>There are two ways of calculating the SED, depending on the way the dermal absorption of a compound is reported:</strong></p>

<p>• Dermal absorption of test substance reported in µg/cm²:</p>
<p><code>SED = [DAa(µg/cm²) × 10⁻³ (mg/µg) × SSA(cm²) × F(day⁻¹) × R] / 60 (kg)</code></p>

<p>• Dermal absorption reported as a percentage of the amount of substance applied:</p>
<p><code>SED = A(mg/kg bw/day) × C(%) / 100 × DAp(%) / 100</code></p>

<p><strong>Definitions:</strong></p>
<ul>
  <li><strong>SED (Systemic Exposure Dose):</strong> The amount of a cosmetic ingredient expected to enter the bloodstream, expressed in mg/kg body weight/day.</li>
  <li><strong>A (mg/kg bw/day):</strong> Estimated daily exposure to a cosmetic product per kg body weight, based upon the amount applied and the frequency of application.</li>
  <li><strong>C (%):</strong> Concentration of the substance under study in the finished cosmetic product on the application site.</li>
  <li><strong>DAp (%):</strong> Dermal absorption expressed as a percentage of the test dose assumed to be applied in real-life conditions. In the absence of data, 50% is used as the default value.</li>
  <li><strong>Retention factor:</strong> A coefficient used as a measure of how much of the cosmetic product remains on the skin after use.</li>
</ul>

<p><strong>Product Type:</strong> {{pf}}</p>
<p><strong>A (mg/kg bw/day):</strong> {{au}}</p>
<p><strong>A (mg/kg bw/day) for preservatives:</strong> For preservatives, a global daily exposure dose must be calculated based on all cosmetic products used by a person. The total value of 2.79 g/day or 269 mg/kg bw/day must be used in the Margin of Safety (MoS) calculation under worst-case exposure.</p>
<p><strong>Surface Area for Application:</strong>{{ya}}</p>
<p><strong>Default Human Body Weight:</strong>{{we}}</p>
<p><strong>Reference:</strong>{{ref}}</p>
`;

profile=`<p><b>8)	Formülde yer alan maddelerin toksikolojik profili</b></p>
<p>Bitmiş üründeki her bir maddenin toksikolojik tehlikesinin tanımlaması, potansiyel maruziyetinin belirlenmesi ve risk karakterizasyonu düzenlenmelidir.</p>
<p><b>Doz – Cevap İlişkisinin Değerlendirilmesi</b></p><p>
Alınan maddenin dozu ile maruz kalan popülasyonda istenmeyen etkilerin görülme sıklığı/şiddeti arasındaki ilişkinin değerlendirilmesi işlemidir. Maruziyet ve toksik cevap arasındaki ilişki için uygulamada bir kalkış noktası yani POD belirlenir. POD, doz cevap noktası olarak insana uyarlanan en düşük dozun (eşik limit değeri olan ve olmayan bileşikler) başlangıç noktasıdır. NOAEL değerleri POD olarak kullanılabilir.
</p>
<p>MOS=PODsys/SED</p>
<p>Bir eşik limit değeri olan bileşenler için NOAEL, LOAEL(toksik etkinin görüldüğü en düşük dozu), BMDL (en düşük BMD değeri) değerleri POD olarak kullanılacaktır. </p>
<p>NOAEL değeri erişilebilir olmadığında, NOEL, LOAEL, LOEL gibi diğer referans toksikoloji değerleri, güvenlilik sınırının hesaplanmasında kullanılacaktır.</p>
<p>Maddelerin toksikolojik güvenlilik sınırı (MoS değeri) 100’ün üzerinde olan ürünler güvenli kabul edilir. Yetişkinlerde MoS 100’den büyük olmalıdır.</p>
`;

profilean=`<p><b>8) Toxicological Profile of the Substances in the Formulation<b/></p>
    <p>
        For each substance in the finished product, the toxicological hazard must be identified, potential exposure must be determined, and a risk characterization must be conducted.
    </p>

    <p><strong>Calculation of the Margin of Safety of a Cosmetic Ingredient</strong></p>
    <p>
        It is the process of evaluating the relationship between the dose of a substance taken and the frequency and/or severity of adverse effects observed in the exposed population.
        To assess the relationship between exposure and toxic response, a <strong>Point of Departure (POD)</strong> is established in practice.
        The POD serves as the starting point for determining the dose-response relationship and represents the lowest dose adapted to humans at which no or minimal adverse effects are observed.
        This can apply to both threshold and non-threshold substances. <strong>NOAEL (No Observed Adverse Effect Level)</strong> values can be used as the POD.
    </p>
    <p>MOS=PODsys/SED</p>

    <p>For substances with a threshold limit, values such as NOAEL (No Observed Adverse Effect Level), LOAEL (Lowest Observed Adverse Effect Level), and BMDL (Benchmark Dose Lower Confidence Limit) are used as the Point of Departure (POD).</p>
    <p>When a NOAEL value is not available, alternative reference toxicological values such as NOEL (No Observed Effect Level), LOAEL, or LOEL (Lowest Observed Effect Level) may be used to calculate the safety margin.</p>
    <p>The toxicological safety threshold of substances is evaluated through the Margin of Safety (MoS). A product is considered safe when the MoS value is greater than 100, particularly in adult populations. This threshold accounts for interspecies and intraspecies variability (a default uncertainty factor of 10 for each), ensuring a conservative approach to human health protection.</p>
    `;


    a9=`<p><b>9)	İstenmeyen etkiler ve ciddi istenmeyen etkiler</b></p><p>Bir kozmetik ürünün normal ya da öngörülebilir kullanımı sonrasında, insan sağlığını olumsuz etkileyen beklenmedik etkiye İstenmeyen Etki (İE); geçici veya kalıcı fonksiyonel yetersizlik, sakatlık, hastanede tedavi altına alınma, konjenital anomaliler veya ani yaşamsal risk ya da ölümle sonuçlanan istenmeyen bir etkiye ise Ciddi İstenmeyen Etki (CİE) denir.</p><p>Ürünün piyasaya arzı sonrası kullanımında üründen kaynaklanan istenmeyen etkileri toplanmalı, belgelendirilmeli, nedensellik kurulmalı ve yönetecek bir sistem kurulmalıdır. Ciddi istenmeyen etkiler olduğunda Kurum bilgilendirilmelidir.</p><p>Sorumlu kişi tarafında verilen bilgilere istinaden herhangi bir istenmeyen etki veya ciddi istenmeyen etki gözlenmemiştir.</p>`;
    a9en=`<p><b>9)	Undesirable effects and serious undesirable effects</b></p><p> An adverse effect (AE) is an unexpected effect that negatively impacts human health following the normal or foreseeable use of a cosmetic product. A serious adverse effect (SAE) refers to an undesirable effect that leads to temporary or permanent functional impairment, disability, hospitalization, congenital anomalies, sudden life-threatening situations, or death.</p><p>After the product is placed on the market, any adverse effects resulting from the product's use should be collected, documented, causality should be established, and a management system should be implemented. In cases of serious adverse effects, the relevant authorities must be notified.</p><p>Based on the information provided by the responsible person, no adverse effects or serious adverse effects have been observed.</p>`;


    a10=`<p><b>10)	Kozmetik Ürün Bilgisi </b></p>
    <p>Raporda değerlendirilen ürünün içeriğinde bulunan hammaddellerin maruziyet değerlendirmesi ve güvenlilik sınırlaması hesaplanmanmış olup ürünün dermatolojik test raporuna göre; Cilt Uyumluluk Testi gerekliliklerini karşıladığı ve tahriş edici olmadığı sonucuna varıyoruz. 
</p><p>Ürüne ait Ürün Bilgi Dosyası içerisinde aşağıdaki dokümanlara ulaşabilirsiniz.
</p>
    <p>1.	Ürün Formülasyonu </p>
    <p>2.	Hammadde MSDS’ leri</p>
    <p>3.	Bitmiş Ürün Spesifikasyonu </p>
    <p>4.	Stabilite Test Raporu </p>
    <p>5.	Challenge Test Raporu </p>
    <p>6.	Mikrobiyolojik Test Raporu </p>
    <p>7.	GMP Belgesi </p>
    <p>8.	Üretim Metodu </p>
    <p>9.	Ambalaj Kalite Belgesi (TDS/MSDS)</p>
    <p>10.	Ürünün Etiket Bilgisi</p>

    `;
    a10en=`<p><b>10)	Cosmetic Product Information</b></p>
    <p>The exposure assessment and safety margin calculation of the raw materials in the evaluated product have been completed. According to the product's dermatological test report, we conclude that the product meets the requirements of the Skin Compatibility Test and is not irritating.

</p><p>You can find the following documents in the Product Information File for the product:
</p>
    <p>1.	Product Formulation</p>
    <p>2.	Raw Material MSDSs</p>
    <p>3.	Finished Product Specification </p>
    <p>4.	Stability Test Report </p>
    <p>5.	Challenge Test Report </p>
    <p>6.	Microbiological Test Report</p>
    <p>7.	GMP Certificate</p>
    <p>8.	Manufacturing Method</p>
    <p>9.	Packaging Quality Certificate (TDS/MSDS)</p>
    <p>10.	Product Label Information</p>

    `;

    b1= `<p>
<b>Değerlendirme sonucu,</b></p><p> bu rapor; Regulation (EC) No 1223/2009, Türkiye İlaç ve Tıbbi Cihaz Kurumu Kozmetik Ürünlerde Güvenlilik Değerlendirmesine İlişkin Kılavuz Sürüm 3.0, SCCS'nin Kozmetik İçeriklerin Test Edilmesine ve Güvenlik Değerlendirmesine İlişkin Kılavuz Notları 12. Revizyonu, Avrupa Parlamentosu ve Konseyi'nin kozmetik ürünlere ilişkin 30 Kasım 2009 tarihli ve (EC) 1223/2009 sayılı Yönetmeliği, CIR (Kozmetik İçerik İncelemesi), EFSA (Avrupa Gıda Güvenliği Otoritesi) ve ECHA (Avrupa Kimyasallar Ajansı) verilerine dayanarak hazırlanmıştır.
</p>

<p>
Formülasyonda kullanılan hammaddeler, bu konsantrasyonlarda normal ve öngörülebilir koşullar altında kullanıldıklarında toksik değildir. Ürün; 5324 sayılı Kozmetik Kanunu, Kozmetik Yönetmeliğinde Değişiklik Yapılmasına Dair Yönetmelik ve Yönetmelik Ekleri’nde yer alan yasaklı maddeler listesindeki herhangi bir maddeyi içermemektedir.
</p>

<p>
Sorumlu kişi, ürünün piyasaya sürülmesini takiben ortaya çıkan ilave bilgiler ışığında; ürünün formülünde, hammaddenin temin edildiği kaynaklarda veya önerilen kullanım şeklinde yapılacak herhangi bir değişiklik durumunda, kozmetik ürün güvenlilik değerlendirme raporunun güncellenmesini sağlamalıdır.
</p>

<p>
Bu ürün, normal veya makul öngörülebilir kullanım şartlarında kullanıldığında insan sağlığı açısından güvenlidir.
</p>
`;
    b1en= `<p>
<b>1) Assessment conclusion<b>
</p>

<p>
This report has been prepared based on the Turkish Cosmetics Law No. 5324, the Cosmetics Product Safety Assessment Guidelines Version 3.0 by the Turkish Medicines and Medical Devices Agency, the SCCS (Scientific Committee on Consumer Safety) Notes of Guidance for the Testing and Safety Assessment of Cosmetic Ingredients, 11th Revision, the European Parliament and Council Regulation (EC) No. 1223/2009 of November 30, 2009, CIR (Cosmetic Ingredient Review), EFSA (European Food Safety Authority), and ECHA (European Chemicals Agency) data.
</p>

<p>
The raw materials used in the formulation, when used under normal and foreseeable conditions at these concentrations, are not toxic. The product does not contain any substances listed in the prohibited substances list found in the Cosmetics Law No. 5324, the Cosmetics Regulation Amendment, and the Annexes of the Regulation.
</p>

<p>
The Responsible Person must ensure that the Cosmetic Product Safety Assessment Report is updated in light of any relevant additional information arising after the product has been placed on the market, or in the event of any change to the product’s formulation, the source of raw materials, or the recommended conditions of use.
</p>

<p>
This product is safe for human health when used under normal or reasonably foreseeable conditions of use.
</p>
`;
    b2= `<p><strong>
2) Etiketlenmiş uyarılar ve kullanım talimatları</strong>
</p>

<p>
<strong>Etiket bilgisi:</strong><br>
Ürün kullanım şekli ve kullanım sıklığı:
</p>

<p>
<strong>Etikette yer alan uyarılar:</strong>
</p>
`;
    b2en= `<p><strong>
2) Labelled warnings and instructions for use</strong>
</p>

<p>
<strong>Label Information:</strong><br>
Product usage instructions and frequency of use:
</p>

<p>
<strong>Warnings on the label:</strong>
</p>
`;
    b3= `<p><strong>
3) Gerekçelendirme</strong>
</p>

<p>
5324 Sayılı Kozmetik Kanunu ve 08.05.2023 tarihli ve 32184 Mükerrer sayılı Resmi Gazetede yayımlanarak yürürlüğe giren Kozmetik Ürünler Yönetmeliği gereğince, “formülasyonda yer alan her bir maddenin, karışımın ve bitmiş ürünün güvenliliği, kozmetik ürünün içerdiği maddelerin olası etkileşimleri, bileşenlerin toksikolojik profili, stabilitenin kozmetik ürünün güvenliliği üzerindeki etkisi, bitmiş kozmetik üründe bulunan maddelerin planlı ve makul öngörülebilir maruziyet koşulları, ürünün dayanıklılık verileri ve ambalaj materyali ile uyumu değerlendirilmiştir.
</p>

<p>
Vücut temizliği için kullanılan ve durulanan bir üründür. Hedef kitlesi yetişkinlerdir.
</p>

<p>
Formülasyonda kullanılan parfüm konsantrasyonu, IFRA’nın 51. Değişikliği (51st Amendment) kapsamında ------- kategoriye ait güvenlik ve kullanım limitlerine uygun şekilde düzenlenmiştir.
</p>

<p>
Bitmiş ürün formülasyonunda parfüm veya aroma bileşeni bulunmadığından, IFRA kapsamına giren herhangi bir değerlendirme yapılmamıştır.
</p>

<p>
Bitmiş ürün spesifikasyonları ve her bir hammadde için üreticilerden alınan hammadde spesifikasyonları değerlendirilmiştir.
</p>

<p>
Ürün stabilitesi, üretici tarafından sunulan “stabilite test raporu”na göre değerlendirilmiştir. Normal şartlar altında depolandığı takdirde, stabilite testi süresi boyunca belirtilen test sıcaklıklarında ürünün başlangıçtaki fonksiyonlarını yerine getirmeye devam ettiği ve herhangi bir sapma/ayrışma gözlenmediği belirtilmiştir.
</p>

<p>
Ambalaj üzerinde belirtilen simgeye göre, ürünün açılmasından itibaren güvenli kullanım süresi (PAO) 12 aydır.
</p>

<p>
“Türkiye İlaç ve Tıbbi Cihaz Kurumu Kozmetik Ürünlerin Mikrobiyolojik Kontrolüne İlişkin Kılavuz” gereği kozmetik ürünlerde kesinlikle bulunmaması gereken mikroorganizmalar <em>Staphylococcus aureus</em>, <em>Pseudomonas aeruginosa</em>, <em>Candida albicans</em> ve <em>Escherichia coli</em>’dir.
</p>

<p>
Bu ürün Kategori 2 kapsamında değerlendirilmektedir. Kategori 2’ye göre değerlendirildiğinde ürünün mikrobiyolojik kalitesi uygundur.
</p>

<p>
Koruyucu etkinlik test sonucuna göre, üretici bu üründe koruyucunun etkinliğini deneysel olarak garanti etmiştir.
</p>

<p>
Verilen bilgilere istinaden üretim süreci, formül ve ambalaj malzemesine göre üründe istenmeyen maddeler gözlenmemiştir.
</p>

<p>
Kozmetik ürün İyi Üretim Uygulamalarına (GMP) göre üretildiğinden, bu formülasyonda yasaklı madde izlerinin bulunması beklenmez.
</p>

<p>
Kullanım, uyarılar ve diğer açıklamalar etiket üzerindedir. Ürünün etiketi, normal ve makul olarak öngörülebilir kullanımı tanımlamak için yeterlidir.
</p>

<p>
Ürün formülasyonunda yer alan hammaddeler için maruziyet (exposure) değerlendirmesi ve güvenlilik sınırı (Margin of Safety – MoS) hesaplamaları gerçekleştirilmiştir. MoS değeri hesaplanan tüm bileşenler için <strong>MoS ≥ 100</strong> kriteri sağlanmıştır. MoS değeri hesaplanamayan hammaddeler için ise, güvenli kozmetik kullanımına ilişkin geçerli bilimsel literatür, mevzuat veya yetkili otoritelerce yayımlanmış referanslar doğrultusunda kullanılabilirlikleri desteklenmiştir.
</p>

<p>
Sorumlu Kişi tarafından sağlanan bilgilere göre olumsuz etkilerle ilgili hiçbir veri tarafımıza bildirilmemiştir.
</p>

<p>
Ürünle ilgili kanıtlanması gereken herhangi bir iddia bulunmamaktadır.
</p>
`;
    b3en= `<p><strong>
3) Reasoning</strong>
</p>

<p>
In accordance with the Cosmetics Law No. 5324, the Cosmetics Products Regulation published in the Official Gazette dated 08.05.2023 and numbered 32184 (Duplicate), Regulation (EC) No. 1223/2009 of the European Parliament and of the Council of 30 November 2009 on cosmetic products, and the SCCS’s Notes of Guidance for the Testing of Cosmetic Ingredients and Their Safety Evaluation – 12th Revision, the safety of each substance, mixture, and the finished product included in the formulation has been assessed. This assessment includes the potential interactions between ingredients, the toxicological profiles of the components, the impact of stability on the product’s safety, the reasonably foreseeable conditions of exposure to substances in the finished product, the product's durability data, and the compatibility of the packaging material with the cosmetic formulation.
</p>

<p>
It is a rinse-off product used for body cleansing. The target population is adults.
</p>

<p>
The fragrance concentration used in the formulation has been adjusted in accordance with the safety and usage limits specified for Category [___] under the 51st Amendment of the IFRA (International Fragrance Association) Standards.
</p>

<p>
Since the finished product formulation does not contain any perfume or fragrance components, no assessment within the scope of IFRA has been conducted.
</p>

<p>
The finished product specifications and the raw material specifications obtained from the manufacturers for each ingredient have been evaluated.
</p>

<p>
The product's stability has been assessed based on the “Stability Test Report” provided by the manufacturer. It has been stated that, when stored under normal conditions, the product maintained its initial functional properties throughout the duration of the stability testing at the specified test temperatures, and no deviation or separation was observed.
</p>

<p>
According to the symbol indicated on the packaging, the product has a Period After Opening (PAO) of 12 months.
</p>

<p>
According to the “SCCS’s Notes of Guidance for the Testing of Cosmetic Ingredients and Their Safety Evaluation – 12th Revision”, the following microorganisms must not be present in cosmetic products under any circumstances: <em>Staphylococcus aureus</em>, <em>Pseudomonas aeruginosa</em>, <em>Candida albicans</em>, and <em>Escherichia coli</em>.
</p>

<p>
This product is classified under Category 2. When assessed according to Category 2, the product's microbiological quality is found to be acceptable.
</p>

<p>
According to the preservative efficacy test results, the manufacturer has experimentally guaranteed the effectiveness of the preservative in this product.
</p>

<p>
Based on the provided information, no undesirable substances have been observed in the product according to the manufacturing process, formulation, and packaging materials.
</p>

<p>
Since the cosmetic product is manufactured according to Good Manufacturing Practices (GMP), traces of prohibited substances are not expected to be present in this formulation.
</p>

<p>
The instructions for use, warnings, and other statements are provided on the label. The product's label is sufficient to define the normal and reasonably foreseeable use.
</p>

<p>
Exposure assessment and Margin of Safety (MoS) calculations have been carried out for the raw materials included in the product formulation. The MoS value meets the <strong>MoS ≥ 100</strong> criterion for all components for which MoS has been calculated. For raw materials where the MoS value could not be calculated, their usability has been supported based on valid scientific literature, regulations, or references published by competent authorities regarding safe cosmetic use.
</p>

<p>
According to the information provided by the Responsible Person, no data regarding adverse effects have been reported to us.
</p>

<p>
There are no claims regarding the product that need to be substantiated.
</p>
`;
    b4= `<p><strong>4)	Güvenlilik değerlendirme sorumlusunun referans mektubu ve nihai onayı.</strong></p><p>Güvenlilik Değerlendirme Sorumlusunun İsmi: </p><p>Güvenlilik Değerlendirme Sorumlusunun Adresi: </p>`;
    b4en= `<p><strong>4)	Reference letter and final approval by the responsible safety assessor</strong></p><p>Name of the Safety Assessor:</p><p>Address of the Safety Assessor:</p>`;

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  ngOnInit() {
    this.definitionForm=this.formBuilder.group({
      'name':['',Validators.required],
      'functionName':['',Validators.required],
      'authorizedPersonel':[''],
      'address':[''],
      'language':['1'],
      'durulanan':['0.01'],
      'a2':[''],    
      'properties':this.formBuilder.array([]),
      'parta':['<p><strong>Kısım A: Kozmetik Ürün Güvenlilik Bilgileri</strong></p><p>1) Kozmetik ürünün kantitatif ve kalitatif bileşimi</p><p>2) Kozmetik ürünün fiziksel/kimyasal özellikleri ve stabilitesi</p><p>a) Madde veya karışımların fiziksel ve kimyasal özellikleri</p><p>b) Bitmiş kozmetik ürünün fiziksel ve kimyasal özellikleri</p><p>c) Kozmetik ürünün stabilitesi</p><p>3) Mikrobiyolojik Kalite</p><p>a) Maddeler ve karışımların mikrobiyolojik kalitesi</p><p>b) Bitmiş Ürünün Mikrobiyolojik Kalitesi</p><p>4) Safsızlıklar, kalıntılar, ambalaj materyali hakkında bilgi</p><p>a) Maddeler ve karışımların saflığı</p><p>b) Yasaklı madde kalıntılarının teknik olarak kaçınılmazlığının kanıtı</p><p>c) Ambalaj materyalinin ilgili özellikleri</p><p>5) Normal ve makul olarak öngörülebilir kullanım</p><p>6) Kozmetik ürüne maruziyet</p><p>7) Formülde yer alan maddelere maruziyet değerlendirmesi</p><p>8) Formülde yer alan maddelerin toksikolojik profili</p><p>9) İstenmeyen etkiler ve ciddi istenmeyen etkiler</p><p>10) Kozmetik Ürün Bilgisi</p>'],
      'partb':['<p><strong>Kısım B: Kozmetik Ürün Güvenlilik Değerlendirmesi</strong></p><p>1) Değerlendirme sonucu,</p><p>2) Etiketlenmiş uyarılar ve kullanım talimatları,</p><p>3) Gerekçelendirme,</p><p>4) Güvenlilik değerlendirme sorumlusunun referans mektubu ve nihai onayı.</p>'],
      'heat':['Oda sıcaklığı, 55°C, 4°C'],
      'params':['Görünüm, Renk, Koku pH, ambalaj, mikrobiyolojik parametreler'],
      'stability':['<p>Ürün stabilitesi 90 gün boyunca verilen sıcaklıklarda ve ürünün orijinal paketinde test edilmiştir.</p><p>Normal şartlar altında depolandığı takdirde, stabilite testi süresi boyunca yukarıda belirtilen test sıcaklıklarında kontrol parametrelerinin, başlangıçtaki fonksiyonlarını yerine getirmeye devam ettiği ve herhangi bir sapma/ayrışma gözlenmediği belirtilmiştir.</p><p><b>-Stabilite test raporu, raporun sonunda sunulmuştur.</b></p>'],
      'bestbefore':['<p>Ambalaj üzerinde belirtilen simgeye göre, ürünün açılmasından itibaren güvenli kullanım süresi (PAO) 12 aydır.</p>'],
      'mikro':[this.mikro],
      'saf':[this.saf],
      'safdevam':[this.safdevam],
      'bottleName':[''],
      'bottleMaterial':[''],
      'bottleColor':[''],
      'bottleVolume':[''],
      'bottleHeight':[''],
      'bottleDiameter':[''],
      'bottleWidth':[''],

      'lidName':[''],
      'lidMaterial':[''],
      'lidColor':[''],
    
      'lidHeight':[''],
      'lidDiameter':[''],
      'lidWidth':[''],
      'lidInDiameter':[''],
      'lidUpDiameter':[''],
      'usage':[this.usage],
      'degerlendirme':[this.degerlendirme],
      'ifras':this.formBuilder.array([]),
      'profile':[this.profile],
      'age':['100'],
      'a9':[this.a9],
      'a10':[this.a10],
      'b1':[this.b1],
      'b2':[this.b2],
      'b3':[this.b3],
      'b4':[this.b4],

    });

    this.editor = new Editor();
    this.editorb = new Editor();
    this.editor3= new Editor();
    this.editor4 = new Editor();
    this.editormikro=new Editor();
    this.editorsaf=new Editor();
    this.editorsafdevam=new Editor();
    this.editorusage=new  Editor();
    this.editordegerlendirme=new Editor();
    this.editorprofile=new Editor();
    this.editora9=new Editor();
    this.editora10=new Editor();
    this.editorb1=new Editor();
    this.editorb2=new Editor();
    this.editorb3=new Editor();
    this.editorb4=new Editor();
    this.editor2a=new Editor();
    this.getCategories();
    this.getProperties();
  }

  selectedCategory:any;

categories:any[]=[];
  getCategories(){
    this.categorySerivice.getCompounds().subscribe(res=>{
      this.categories=res;
    })
  }
  
  ngOnDestroy(): void {
    this.editor.destroy();
    this.editorb.destroy();
    this.editor3.destroy();
    this.editor4.destroy();
    this.editormikro.destroy();
    this.editorsaf.destroy();
    this.editorsafdevam.destroy();
    this.editorusage.destroy();
    this.editordegerlendirme.destroy();
    this.editorprofile.destroy();
    this.editora9.destroy();
    this.editora10.destroy();
    this.editorb1.destroy();
    this.editorb2.destroy();
    this.editorb3.destroy();
    this.editorb4.destroy();
    this.editor2a.destroy();
  }

  save(){
  
var catId=this.selectedCategory.id;
var liste=[];
this.compounds.forEach(element=>{
    liste.push({
      copoundId:element.madde.id,
      name:element.madde.name,
      consantration:element.consantration,
      materials:element.madde.materials.map(e=> 
        ({
          materialId:e.materialId,
          cosingId:e.material.cosingId,
          inciName:e.material.inciName,
          cas:e.material.cas,
          einecs:e.material.einecs,
          function:e.material.function,
          annex:e.material.annex,
          hu:e.hu,
          bu:e.bu,
          extra:e.material.extra,
          maxConsantrasyon:e.material.maxConsantrasyon,
          noael:e.material.noael,
          references:e.material.references,
          toksicology:e.material.toksicology,
          isAllergen:e.material.isAllergen

        })),
        properties:element.madde.properties? element.madde.properties.map(e=>({property:e.property,value:e.value,method:e.method})):[],
        pureness:element.madde.pureness? element.madde.pureness.map(e=>({name:e.name,limit:e.limit,spesification:e.spesification})):[]

    })
})


console.log(this.definitionForm.value);

    var model= {...{annex:this.annex},...{parfume:this.parfume=="1"}, ...this.definitionForm.value,...{allergens:this.allergenes.map(e=>({
       materialId:e.madde.id,
          cosingId:e.madde.cosingId,
          inciName:e.madde.inciName,
          cas:e.madde.cas,
          einecs:e.madde.einecs,
          function:e.madde.function,
          annex:e.madde.annex,
          pc:e.pc,
          fc:e.fc,
          extra:e.madde.extra,
          maxConsantrasyon:e.madde.maxConsantrasyon,
          noael:e.madde.noael,
          references:e.madde.references,
          toksicology:e.madde.toksicology,
    }))}, ...{categoryId:catId} ,...{compounds:liste}}; 



    this.productService.addHammadde(model).subscribe(res=>{
        this.toastr.success('','Kayıt başarılı');
    });

  }

  
  onChange(val){
 

    if(val=="1"){
      this.definitionForm.get("parta").patchValue('<p><strong>Kısım A: Kozmetik Ürün Güvenlilik Bilgileri</strong></p><p>1) Kozmetik ürünün kantitatif ve kalitatif bileşimi</p><p>2) Kozmetik ürünün fiziksel/kimyasal özellikleri ve stabilitesi</p><p>a) Madde veya karışımların fiziksel ve kimyasal özellikleri</p><p>b) Bitmiş kozmetik ürünün fiziksel ve kimyasal özellikleri</p><p>c) Kozmetik ürünün stabilitesi</p><p>3) Mikrobiyolojik Kalite</p><p>a) Maddeler ve karışımların mikrobiyolojik kalitesi</p><p>b) Bitmiş Ürünün Mikrobiyolojik Kalitesi</p><p>4) Safsızlıklar, kalıntılar, ambalaj materyali hakkında bilgi</p><p>a) Maddeler ve karışımların saflığı</p><p>b) Yasaklı madde kalıntılarının teknik olarak kaçınılmazlığının kanıtı</p><p>c) Ambalaj materyalinin ilgili özellikleri</p><p>5) Normal ve makul olarak öngörülebilir kullanım</p><p>6) Kozmetik ürüne maruziyet</p><p>7) Formülde yer alan maddelere maruziyet değerlendirmesi</p><p>8) Formülde yer alan maddelerin toksikolojik profili</p><p>9) İstenmeyen etkiler ve ciddi istenmeyen etkiler</p><p>10) Kozmetik Ürün Bilgisi</p>');
      this.definitionForm.get("partb").patchValue('<p><strong>Kısım B: Kozmetik Ürün Güvenlilik Değerlendirmesi</strong></p><p>1) Değerlendirme sonucu,</p><p>2) Etiketlenmiş uyarılar ve kullanım talimatları,</p><p>3) Gerekçelendirme,</p><p>4) Güvenlilik değerlendirme sorumlusunun referans mektubu ve nihai onayı.</p>');
    this.definitionForm.get("heat").patchValue('Oda sıcaklığı, 55°C, 4°C');
    this.definitionForm.get("params").patchValue('Oda sıcaklığı, 55°C, 4°C');
    this.definitionForm.get("stability").patchValue('<p>Ürün stabilitesi 90 gün boyunca verilen sıcaklıklarda ve ürünün orijinal paketinde test edilmiştir.</p><p>Normal şartlar altında depolandığı takdirde, stabilite testi süresi boyunca yukarıda belirtilen test sıcaklıklarında kontrol parametrelerinin, başlangıçtaki fonksiyonlarını yerine getirmeye devam ettiği ve herhangi bir sapma/ayrışma gözlenmediği belirtilmiştir.</p><p><b>-Stabilite test raporu, raporun sonunda sunulmuştur.</b></p>');
    this.definitionForm.get("bestbefore").patchValue('<p>Ambalaj üzerinde belirtilen simgeye göre, ürünün açılmasından itibaren güvenli kullanım süresi (PAO) 12 aydır.</p>');  
    this.definitionForm.get("mikro").patchValue(this.mikro);
    this.definitionForm.get("saf").patchValue(this.saf);
    this.definitionForm.get("safdevam").patchValue(this.safdevam);
    this.definitionForm.get("usage").patchValue(this.usage);
    this.definitionForm.get("degerlendirme").patchValue(this.degerlendirme);
    this.definitionForm.get("profile").patchValue(this.profile);
    this.definitionForm.get("a9").patchValue(this.a9);
    this.definitionForm.get("a10").patchValue(this.a10);
    this.definitionForm.get("b1").patchValue(this.b1);
    this.definitionForm.get("b2").patchValue(this.b2);
    this.definitionForm.get("b3").patchValue(this.b3);
    this.definitionForm.get("b4").patchValue(this.b4);
  
  }
    else{
      this.definitionForm.get("parta").patchValue('<p><strong>Part A: Cosmetic Product Safety Information</strong></p><p>1. Quantitative and qualitative composition of the cosmetic product</p><p>2. Physical/chemical characteristics and stability of the cosmetic product</p><p>a) Physical and chemical properties of substances or mixtures</p><p>b) Physical and chemical properties of the finished cosmetic product</p><p>c) Stability of the cosmetic product</p><p>3. Microbiological Quality</p><p>a) Microbiological quality of substances and mixtures</p><p>b) Microbiological quality of the finished product</p><p>4. Information on impurities, traces, and packaging material</p><p>a) Purity of substances and mixtures</p><p>b) Evidence of the technical unavoidability of traces of prohibited substances</p><p>c) Relevant characteristics of the packaging material</p><p>5. Normal and reasonably foreseeable use</p><p>6. Exposure to the cosmetic product</p><p>7. Exposure assessment of the substances in the formulation</p><p>8. Toxicological profile of the substances in the formulation</p><p>9. Undesirable effects and serious undesirable effects</p><p>10. Cosmetic Product Information</p>');
      this.definitionForm.get("partb").patchValue('<p><strong>Part B: Cosmetic Product Safety Assessment</strong></p><p>1. Assessment conclusion</p><p>2. Labelled warnings and instructions for use</p><p>3. Justification</p><p>4. Reference letter and final approval by the responsible safety assessor</p>');
      this.definitionForm.get("heat").patchValue('Room temperature, 55°C, 4°C');
      this.definitionForm.get("params").patchValue('Appearance, Color, Smell, pH, Packaging, Microbiological parameters');
      this.definitionForm.get("stability").patchValue('<p>The product stability was tested at the specified temperatures for a period of 90 days in the product\'s original packaging.</p><p>Under normal storage conditions, it is indicated that the control parameters continued to function as initially intended during the stability testing period at the aforementioned test temperatures, and no deviations/degradation were observed.</p><p><b>-The stability test report is provided at the end of the report.</b></p>');
      this.definitionForm.get("bestbefore").patchValue('<p>The responsible person has indicated that the product\'s shelf life after opening (PAO) for maintaining its initial functions is 12 months</p>');
      this.definitionForm.get("mikro").patchValue(this.mikroEng);
      this.definitionForm.get("saf").patchValue(this.safen);
      this.definitionForm.get("safdevam").patchValue(this.safdevamen);
      this.definitionForm.get("usage").patchValue(this.usageen);
      this.definitionForm.get("degerlendirme").patchValue(this.degerlendirmeen);
      this.definitionForm.get("profile").patchValue(this.profilean);
      this.definitionForm.get("a9").patchValue(this.a9en);
      this.definitionForm.get("a10").patchValue(this.a10en);
      this.definitionForm.get("b1").patchValue(this.b1en);
      this.definitionForm.get("b2").patchValue(this.b2en);
      this.definitionForm.get("b3").patchValue(this.b3en);
      this.definitionForm.get("b4").patchValue(this.b4en);
    }

    this. updateProp();
  }
  konsantrasyon:any;
  madde:any;

  searching=false;
  searchFailed=false;

  search: OperatorFunction<string, any[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(300),
			distinctUntilChanged(),
			tap(() => (this.searching = true)),
			switchMap((term) =>
				this.compoundService.search(term).pipe(
					tap(() => (this.searchFailed = false)),
					catchError(() => {
						this.searchFailed = true;
						return of([]);
					}),
				),
			),
			tap(() => (this.searching = false)),
		);


    formatter = (x: { name: string }) => x.name;




    madde2:any;
  searching2=false;
  searchFailed2=false;

  search2: OperatorFunction<string, any[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(300),
			distinctUntilChanged(),
			tap(() => (this.searching2 = true)),
			switchMap((term) =>
				this.hammaddeService.search(term,1).pipe(
          tap((results) => {
            console.log('Arama sonuçları:', results); // burada sonuçları görmelisin
            this.searchFailed2 = false;
          }),
					catchError(() => {
						this.searchFailed2 = true;
						return of([]);
					}),
				),
			),
			tap(() => (this.searching2 = false)),
		);


    formatter2 = (x: { inciName: string }) => x.inciName;

    allergenes:any[]=[];

    
    madde3:any;
  searching3=false;
  searchFailed3=false;

  search3: OperatorFunction<string, any[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(300),
			distinctUntilChanged(),
			tap(() => (this.searching3 = true)),
			switchMap((term) =>
				this.hammaddeService.searchAllergen(term).pipe(
          tap((results) => {
            console.log('Arama sonuçları:', results); // burada sonuçları görmelisin
            this.searchFailed3 = false;
          }),
					catchError(() => {
						this.searchFailed3 = true;
						return of([]);
					}),
				),
			),
			tap(() => (this.searching3 = false)),
		);


    formatter3 = (x: { inciName: string }) => x.inciName;

    pc:any;
  

    addAllergen(){


       var parfume=this.compounds.find(e=>e.madde.name=="PARFUM" || e.madde.name=="Parfum");

       if(parfume==null){
          this.toastr.error('', 'Ürün formülünde parfüm yok. Önce giriniz.');
          return;
       }

      
        var parfumeCons=parfume.consantration;
       // var fc=Number(Number(this.pc)*parfumeCons/100).toPrecision(10).toString();
   const fc = new Decimal.Decimal(this.pc).mul(parfumeCons).div(100);
      this.allergenes.push({
        madde:this.madde3,

pc:this.pc,
fc:fc

      });

      this.pc=null;
      this.madde3=null;

    }

    checkParfume(){
      this.allergenes=[];
      if(this.parfume=="1"){
       this.addIfra();

        // this.compounds.forEach(element=>{
        //   element.madde.materials.forEach(data=>{

        //     if(data.material.isAllergen)
        //       this.addAllergen(data.material);
        //   });
        // });

      }
      else{
     
      }
    }

    removeAllergen(index){
      this.allergenes.splice(index,1);
    }

    hm=100;

    addMadde2(){

      if(this.konsantrasyon==null){
         this.toastr.error('', 'Lütfen konsantrasyon giriniz.');
         return;
      }

      if(this.madde2==null){
        this.toastr.error('', 'Lütfen hammadde seçiniz.');
        return;
      }

   if(this.compounds.some((x)=>x.madde.name==this.madde2.inciName)){
    this.toastr.error('', 'Bu hammadde zaten ekli.');
    return;
   }

      var bu=(this.konsantrasyon/100)*Number(this.hm);

     let compound={name:this.madde2.inciName,materials:[{material:this.madde2,bu:bu,hm:this.hm}]};



      this.compounds.push({
        madde:compound,
       consantration:this.konsantrasyon??0});
      this.madde2=null;
      this.konsantrasyon=null;
      this.hm=100;
   
    }

    openSaveModal(){
      const modalref=  this.modal.open(AddcategoryComponent, { size: 'lg' });
      modalref.result.then((result)=>{
       this.getCategories();
      });
      }



  

    addMadde(){

         if(this.konsantrasyon==null){
        this.toastr.error('', 'Lütfen konsantrasyon giriniz.');
        return;
      }

      if(this.madde==null){
        this.toastr.error('', 'Lütfen hammadde seçiniz.');
        return;
      }

      
      if(this.compounds.some((x)=>x.madde.name==this.madde.name)){
        this.toastr.error('', 'Bu bileşik zaten ekli');
        return;
      }


        this.madde.materials.forEach((element)=>{
            if(element.hm){
              element.bu=(this.konsantrasyon/100)*Number(element.hm);
            }
        });

        this.compounds.push({madde:this.madde,consantration:this.konsantrasyon??0});
        this.madde=null;
        this.konsantrasyon=null;
        console.log(this.compounds);
    }

    removeMadde(index){
      this.compounds.splice(index, 1);
    }



    getProperties(){
      this.properrtyService.getHammaddeler().subscribe(res=>{
        this.properties=res;
        this.properties.forEach((element)=>{
          console.log(element.name);
         var resportLang=this.definitionForm.get("language").value;
         if(resportLang=="1")
          this. addProjectDutyPerson(element.name)
        else  
         this. addProjectDutyPerson(element.englishName)
        })
      });
  
    }


    updateProp(){
      var resportLang=this.definitionForm.get("language").value;
      this.getProjectDutyPerson().clear();
      this.properties.forEach((element)=>{
        console.log(element.name);
       if(resportLang=="1")
        this. addProjectDutyPerson(element.name)
      else  
       this. addProjectDutyPerson(element.englishName)
      })
    }

    
  getProjectDutyPerson() {
    return this.definitionForm.get("properties") as FormArray;
  }

  addProjectDutyPerson(name:any) {
    this.getProjectDutyPerson().push(this.createProjectDutyPerson(name));
  }

  createProjectDutyPerson(name:any): FormGroup {
    return this.formBuilder.group({
      property: [name],
      value: [""],
      method: [""]
     
    });
  }
  
  removeDuty(i) {
    this.getProjectDutyPerson().removeAt(i);
  }



  
  getIfra() {
    return this.definitionForm.get("ifras") as FormArray;
  }

  addIfra() {
    this.getIfra().push(this.createIfra());
  }

  createIfra(): FormGroup {
    return this.formBuilder.group({
      name: [''],
      category: [""],
      mc: [""],
      bc: [""],
      suitable: [""],
    });
  }
  
  removeIfra(i) {
    this.getIfra().removeAt(i);
  }


  editMikro(){
this.showmikro=!this.showmikro;
  }

  editSaf(){
    this.showsaf=!this.showsaf;
  }


  annex:any[]=[];
  checkAnnex(){
      this.annex=[];
    this.compounds.forEach(element => {

      element.madde.materials.forEach(data=>{

        if(data.material.annex){
          
          this.annex.push({
            inciName:data.material.inciName,
            annex:data.material.annex,
            maxConsantrasyon:data.material.maxConsantrasyon,
            productTypes:data.material.productTypes,
            suitable:this.definitionForm.get("language").value=="1"? "Uygun":"Suitable",
            usagePurpose:data.material.usagePurpose,
            other:data.material.other,
           bu:data.bu

          });
        }

      });
    });

    this.allergenes.forEach(data=>{
     if(data.madde.annex){
          
          this.annex.push({
            inciName:data.madde.inciName,
            annex:data.madde.annex,
            maxConsantrasyon:data.madde.maxConsantrasyon,
            productTypes:data.madde.productTypes,
            suitable:this.definitionForm.get("language").value=="1"? "Uygun":"Suitable",
            usagePurpose:data.madde.usagePurpose,
            other:data.madde.other,
           bu:data.bu

          });
        }

    });
  }



  editSuitable(i:any){
      
          const modalref=  this.modal.open(SuitableComponent, { size: 'sm' });
         
          modalref.result.then((result)=>{
            console.log(result);
            if(result){
          this.annex[i].suitable=result;

            }
          });
          
  }



  calculate(){



    if(!this.selectedCategory){
      this.toastr.error('', 'Lütfen önce ürün grubu seçiniz.');
      return;
    } 

    var age=this.definitionForm.get("age").value;
    if(!age){
      this.toastr.error('', 'Lütfen yaş kategorisini seçiniz.');
      return;
    }

    this.sedData=[];
   this. mosData=[];
   var rf=Number(this.definitionForm.get("durulanan").value);

    this.compounds.forEach(element => {
      
      element.madde.materials.forEach(data=>{
        var a=0;
        console.log("Material Function",data);

        if(this.selectedCategory){
            a=this.selectedCategory.a;
        }
        var varmi=data.material.function.includes("PRESERVATIVE");
        if(varmi)
        {
          a=269;
        }
        var sed=new Decimal.Decimal(a).mul(data.bu).mul(50).div(10000).toNumber();
        

        console.log("SED",sed);
        console.log("BU",data.bu);
        console.log("A",a);

       
        var mat={name:data.material.inciName,concantration:data.bu,rf:rf,dp:50,sed:sed.toFixed(10)};
          this.sedData.push(mat);
          var mosc=0;
          if(data.material.noael)
           mosc=new Decimal.Decimal(data.material.noael).div(sed).toNumber();
          

          var print="";
          if(mosc>Number(age))
            print="MoS > "+age+" olduğundan bu hammadenin bu konsantrasyonda bu ürün içinde kullanımı güvenlidir.";

          else
          print="MoS < "+age+" olduğundan bu hammadenin bu konsantrasyonda bu ürün içinde kullanımı güvenli değildir.";

          var mos={name:data.material.inciName,sed:sed.toFixed(10),noael:data.material.noael,mos:mosc.toFixed(10),print:print,reference:data.material.references};

          this.mosData.push(mos);
      });
    });

    this.allergenes.forEach(element=>{
       var a=0;
        console.log("Material Function",element);

        if(this.selectedCategory){
            a=this.selectedCategory.a;
        }
        var varmi=element.madde.function.includes("PRESERVATIVE");
        if(varmi)
        {
          a=269;
        }

      var sed=new Decimal.Decimal(a).mul(element.fc).mul(50).div(10000).toNumber();
      
      var mat={name:element.madde.inciName,concantration:element.fc,rf:rf,dp:50,sed:sed.toFixed(10)};
      this.sedData.push(mat);
      var mosc=0;
      if(element.madde.noael)
       mosc=new Decimal.Decimal(element.madde.noael).div(sed).toNumber();

      var print="";

      if(mosc>Number(age))
        print="MoS > "+age+" olduğundan bu hammadenin bu konsantrasyonda bu ürün içinde kullanımı güvenlidir.";

      else
      print="MoS < "+age+" olduğundan bu hammadenin bu konsantrasyonda bu ürün içinde kullanımı güvenli değildir.";


        if(!element.madde.noael)
        print="İlgili hammadde, kozmetik ürünlerde yaygın şekilde kullanılmaktadır. Sunmuş olduğumuz referans, bu kullanım alanlarına dair kapsamlı bilgi sağlamaktadır.";

      var mos={
        name:element.madde.inciName,
        sed:sed.toFixed(10),
        noael:element.madde.noael,
        mos:mosc.toFixed(10),
        print:print,
        reference:element.madde.references};

      this.mosData.push(mos); 
    });

  }

  hidea2(){
    this.a2=!this.a2;
    console.log(this.a2);
  }

      openEditModal(data:any){
        const modalref=  this.modal.open(NoealComponent);
       modalref.componentInstance.hammadde=data;
        modalref.result.then((result)=>{
        if(result){


    this.compounds.forEach(element => {
      
      element.madde.materials.forEach(element=>{

        if(data.inciName==element.inciName){
          element=result;
        }


      })});
        }
    });
  }




  selectcat(e){
   
   this.degerlendirme= this.degerlendirme.replace("{{pf}}",this.selectedCategory.function);
   this.degerlendirme= this.degerlendirme.replace("{{au}}",this.selectedCategory.a+ " "+ this.selectedCategory.aunit);
   this.degerlendirme= this.degerlendirme.replace("{{ya}}",this.selectedCategory.contactAreaCm2);
   this.degerlendirme= this.degerlendirme.replace("{{we}}",this.selectedCategory.bodyWeight);
   this.degerlendirme= this.degerlendirme.replace("{{ref}}",this.selectedCategory.reference);


     this.degerlendirmeen= this.degerlendirmeen.replace("{{pf}}",this.selectedCategory.functionEnglish);
     this.degerlendirmeen=this.degerlendirmeen.replace("{{au}}",this.selectedCategory.a+ " "+ this.selectedCategory.aunitEnglish);
    this.degerlendirmeen= this.degerlendirmeen.replace("{{ya}}",this.selectedCategory.contactAreaCm2);
    this.degerlendirmeen= this.degerlendirmeen.replace("{{we}}",this.selectedCategory.bodyWeight);
    this.degerlendirmeen= this.degerlendirmeen.replace("{{ref}}",this.selectedCategory.referenceEnglish);

    if(this.definitionForm.get("language").value=="1")
    this.definitionForm.get("degerlendirme").patchValue(this.degerlendirme);
    else
    this.definitionForm.get("degerlendirme").patchValue(this.degerlendirmeen);
  }
}
